import { combineEpics } from "redux-observable";
import "./authoring/index.js";
import { unifiedRootEpic } from "./authoring/epics.js";
const rootEpic = combineEpics(unifiedRootEpic);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
